import { AnfrageListDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model';
import { PortalContextService } from '@/core/services/portal-context.service';
import { Component, Input } from '@angular/core';
import { GutachtenDisplayModel, GutachtenDisplayModelFormGroup, LocalizedTextDisplayModel } from '@/api/model-index';
import { I18nService } from '@/core/services/i18nService';
import { AnfrageDisplayModel } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { IntlService, NumberFormatOptions } from '@progress/kendo-angular-intl';
import { Constants } from '@/constants';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { StateService } from '@/core/services/state.service';

@Component({
  selector: 'review-anfrage-info',
  templateUrl: './review-anfrage-info.component.html',
  styleUrls: ['./review-anfrage-info.component.scss']
})
export class ReviewAnfrageInfoComponent {

  @Input() inputAnfrage: AnfrageDisplayModel| undefined| null = null
  @Input() showBereich: boolean = true
  @Input() showAusschreibung: boolean = true
  @Input() showPhase: boolean = true
  @Input() showProjInfo = true;

  public review: GutachtenDisplayModel;
  public reviewForm: GutachtenDisplayModelFormGroup;
  public attachmentProcessStepForm: UntypedFormGroup = new UntypedFormGroup({
    attachments: new UntypedFormControl(null, []),
  });

  @Input() public attachmentsForm: UntypedFormGroup

  public currencyFormatOptions: NumberFormatOptions = Constants.CURRENCY_FORMAT_OPTIONS;

  public get showProjectInfo() {
    return this.showProjInfo
  }

  public get anfrage(): AnfrageListDisplayModel | null {
    if(this.inputAnfrage == null)
      return this.portalContextService.CurrentAnfrage;
    return this.inputAnfrage;
  }

  public get title(): string {
    if(!this.anfrage)
      return "";

    var projektTitel = this.anfrage.name ?? this.languageservice.instant('newAnfrageTitle');

    return this.anfrage.nummer + " - " + projektTitel;
  }

  public get ausschreibung(): string {
    if(!this.anfrage)
      return "";

    return this.anfrage.ausschreibungName ?? this.languageservice.instant('undefinedText');
  }

  public get phase(): string {
    if(!this.anfrage)
      return "";

    let title: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.anfrage.phase?.name);
    return title?.text ?? this.languageservice.instant('undefinedText');
  }

  public get bereich(): string {
    if(!this.anfrage)
      return "";

    return this.anfrage.foerderprogrammName ?? this.languageservice.instant('undefinedText');
  }

  public get foerdersumme(): number {
    return this.portalContextService.CurrentAnfrage?.financeData?.foerdersumme ?? 0;
  }

  public get attachmentsFormControl(): UntypedFormControl {
    return <UntypedFormControl>this.attachmentsForm.controls["attachments"];
  }

  constructor(protected portalContextService: PortalContextService, protected languageservice: I18nService, protected intlService: IntlService, protected route: ActivatedRoute, protected stateService: StateService) {
    this.reviewForm = GutachtenDisplayModelFormGroup.Instance;
  }
  
  public ngOnInit(): void {
    this.review = this.route.snapshot.data.gutachten;
    this.reviewForm.patchValue(this.portalContextService.CurrentGutachten || this.review);

    if (this.review.anfrage?.attachments != null)
      this.attachmentProcessStepForm.patchValue(this.review.anfrage);
    
    this.attachmentsFormControl.disable();
  }
}
